import { isUndefined } from 'utils/tsHelpers';
import { objFilterOut } from '@iterable/utils';
import { useConditionStateContext } from '../../../../contexts';
import { useConditionState } from '../../../../hooks/condition';
import { EditableCondition } from '../../../../types';

export const useOnConditionValuesReset = () => {
  const { values } = useConditionStateContext();
  const { setCondition, condition } = useConditionState();
  return () => {
    // remove value, adds values if values is undefined
    if (isUndefined(values)) {
      if (values !== null || 'value' in condition) {
        setCondition(
          (condition) =>
            objFilterOut({ ...condition, values: null }, ['value']) as EditableCondition,
        );
      }
    }
  };
};
